module.exports = __webpack_public_path__ + "static/img/employed.2851f275.png";